'use strict';

var constants = require('../../../../_virtual/constants.js_commonjs-exports3.js');

Object.defineProperty(constants.__exports, "__esModule", {
  value: true
});
var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
var MAX_SPECIFICITY = 20;

constants.__exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
constants.__exports.MAX_SPECIFICITY = MAX_SPECIFICITY;

module.exports = constants.__exports;
